import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TvshopConstants } from '../../shared/tvshop-constants';
import { LocalApiService } from '../local-api/local-api.service';
import { map } from 'rxjs/operators';
import { Environment } from '../../shared/environment/environment';
var LanguageService = /** @class */ (function () {
    function LanguageService(router, translateService, localApiService) {
        this.router = router;
        this.translateService = translateService;
        this.localApiService = localApiService;
        this.translateService.setDefaultLang('nl');
    }
    LanguageService.prototype.getLocaleParams = function () {
        return this.router
            .queryParamMap.pipe(map(function (paramMap) { return paramMap.get('locale'); }));
    };
    LanguageService.prototype.setLanguageFromParams = function (locale) {
        if (locale && TvshopConstants.LOCALE_ARRAY.find(function (lang) { return lang === locale; })) {
            this.translateService.use(locale);
        }
    };
    LanguageService.prototype.setLanguage = function () {
        var _this = this;
        this.getLocaleParams().subscribe(function (param) {
            if (param) {
                _this.setLanguageFromParams(param);
            }
            else if (Environment.environmentConfig().environment !== 'local') {
                _this.localApiService.getBoxLanguage().subscribe(function (data) {
                    if (data) {
                        _this.translateService.use(data + '');
                    }
                });
            }
        });
    };
    LanguageService.prototype.getCurrentLanguage = function () {
        if (this.translateService.currentLang) {
            return this.translateService.currentLang;
        }
        return this.translateService.defaultLang;
    };
    return LanguageService;
}());
export { LanguageService };
